<template>
  <!--
    Below this width the drawer is not rendered at all and the same three
    destinations sit in a bar at the foot of the screen. The number is given
    here as well as there so there is no band of widths where the drawer
    collapses into a hamburger that nothing draws.
  -->
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    :mobile-breakpoint="960"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link
        to="/"
        class="d-flex align-center text-decoration-none"
      >
        <v-img
          :src="require('@/assets/images/logos/logo.png')"
          max-height="30px"
          max-width="30px"
          alt="logo"
          contain
          eager
          class="app-logo me-3"
        ></v-img>
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
            {{ systemName }}
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>

        <!-- Navigation Items -->
    <v-list
      expand
      shaped
      class="vertical-nav-menu-items pr-5"
    >
      <!--
        A family's panel is a list of children, not a list of screens: a parent
        with children at two schools has no school of their own.

        It was four items, which was one screen per child plus a chooser on
        each of them - three of the four asked again who was being looked at
        and disagreed about the answer. Tracking, history and alerts are tabs
        of a child now, and a child is reached by tapping their card.
      -->
      <nav-menu-link
        :title="$t('my_children')"
        :to="{ name: 'my-children' }"
        icon="mdi-account-child-outline"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('payments')"
        :to="{ name: 'money' }"
        icon="mdi-wallet-outline"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('contact_the_school')"
        :to="{ name: 'school-contact' }"
        icon="mdi-school-outline"
      ></nav-menu-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
/*
 * The menu a family sees.
 *
 * It was copied from the school's, and came with the school's start-up
 * request: every page a parent opened asked /school-readiness/setup, which is
 * behind the school middleware and answers a family 403. Nothing on this menu
 * ever read the answer.
 */
import NavMenuLink from './components/NavMenuLink.vue'
import { Keys } from '@/config.js'

export default {
  components: {
    NavMenuLink,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      systemName: Keys.VUE_APP_SYSTEM_NAME
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
